module.exports = __webpack_public_path__ + "static/Sample-2-5edbcea65dfaa67c36f001e81d0a6861.png";